import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../layouts/Layout";
import { API_BASE_URL } from "../layouts/constants";
import logo from "../assets/image/eblackdog_logo.png";

const IcoBuilding = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M9 3v18M15 3v18M3 9h18M3 15h18" />
  </svg>
);

const IcoPhone = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.18 2 2 0 0 1 3.59 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.56a16 16 0 0 0 6.29 6.29l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const IcoMail = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const IcoPin = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const IcoGuard = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const IcoRoute = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="6" cy="19" r="3" />
    <circle cx="18" cy="5" r="3" />
    <path d="M12 19h4.5a3.5 3.5 0 0 0 0-7h-8a3.5 3.5 0 0 1 0-7H12" />
  </svg>
);

const IcoShield = ({ size = 14, color = "var(--accent)" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

const IcoArrow = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const IcoAlert = ({ color = "var(--red)" }) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

const IcoPaw = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
    <ellipse cx="6" cy="6" rx="2.5" ry="3" />
    <ellipse cx="12" cy="4" rx="2.5" ry="3" />
    <ellipse cx="18" cy="6" rx="2.5" ry="3" />
    <ellipse cx="3.5" cy="12" rx="2" ry="2.5" />
    <path d="M12 22c-4 0-8-3-8-7 0-2 1.5-3.5 3-4.5 1-.7 2.5-1.5 5-1.5s4 .8 5 1.5c1.5 1 3 2.5 3 4.5 0 4-4 7-8 7z" />
  </svg>
);

export default function AdminDashboard() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [isGuardDashboard, setIsGuardDashboard] = useState(false);

  const [dashboardData, setDashboardData] = useState({
    company_name: "",
    licensedFor: "",
    admin_active: 0,
    company_address: "",
    company_phone: "",
    admin_email: "",
    company_logo: "",
    user_map: "",
    totalGuards: 0,
    activeRoutes: 0,
    hasIsActive: false,
  });

  const [sentinelData, setSentinelData] = useState({
    totalGuards: 0,
    totalRoutes: 0,
    loading: true,
    error: false,
  });

  useEffect(() => {
    const token =
      localStorage.getItem("token") ||
      localStorage.getItem("authToken") ||
      localStorage.getItem("guardToken");

    const isLoggedIn = localStorage.getItem("isLoggedIn");
    const isGuardLoggedIn = localStorage.getItem("isGuardLoggedIn");
    const guardLoginType = localStorage.getItem("guardLoginType");

    let userData = {};
    let guardData = {};

    try {
      userData = JSON.parse(localStorage.getItem("userData") || "{}");
    } catch {
      userData = {};
    }

    try {
      guardData = JSON.parse(localStorage.getItem("guardData") || "{}");
    } catch {
      guardData = {};
    }

    if (!token || (!isLoggedIn && !isGuardLoggedIn)) {
      localStorage.clear();
      navigate("/", { replace: true });
      return;
    }

    if (isGuardLoggedIn === "true") {
  setIsGuardDashboard(true);

  const guardName =
    guardData.fullName ||
    guardData.name ||
    guardData.guardName ||
    guardData.fld_name ||
    localStorage.getItem("guardName") ||
    "Guard";

  const guardEmail =
    localStorage.getItem("guardEmail") ||
    guardData.email ||
    guardData.fld_mail ||
    "";

  const guardPhone =
    localStorage.getItem("guardPhone") ||
    guardData.phone ||
    guardData.mobile ||
    guardData.fld_mobile ||
    "";

  const guardAddress =
    localStorage.getItem("guardAddress") ||
    guardData.address ||
    guardData.fld_address ||
    "";

  setDashboardData({
    company_name: guardName,
    licensedFor:
      guardLoginType === "patrol"
        ? "Patrol Guard Dashboard"
        : "Sentinel Guard Dashboard",
    admin_active: 1,
    company_address: guardAddress,
    company_phone: guardPhone,
    admin_email: guardEmail,
    company_logo: "",
    user_map: localStorage.getItem("user_map") || "",
    totalGuards: 0,
    activeRoutes: 0,
    hasIsActive: false,
  });

  setSentinelData({
    totalGuards: 0,
    totalRoutes: 0,
    loading: false,
    error: false,
  });

  setLoading(false);
  return;
}

    setIsGuardDashboard(false);

    const local = {
      company_name:
        localStorage.getItem("company_name") || userData.company_name || "",
      licensedFor:
        localStorage.getItem("licensedFor") || userData.licensedFor || "",
      admin_active: Number(
        localStorage.getItem("admin_active") ?? userData.admin_active ?? 0
      ),
      company_address:
        localStorage.getItem("company_address") ||
        userData.company_address ||
        "",
      company_phone:
        localStorage.getItem("company_phone") || userData.company_phone || "",
      admin_email:
        localStorage.getItem("admin_email") || userData.admin_email || "",
      company_logo:
        localStorage.getItem("company_logo") || userData.company_logo || "",
      user_map: localStorage.getItem("user_map") || userData.user_map || "",
    };

    setDashboardData((prev) => ({ ...prev, ...local }));
    fetchDashboard(local, token);
  }, [navigate]);

  const fetchDashboard = async (local, token) => {
    try {
      const res = await fetch(`${API_BASE_URL}/dashboard/admin/dashboard`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.status === 401 || res.status === 403) {
        localStorage.clear();
        navigate("/", { replace: true });
        return;
      }

      if (!res.ok) {
        throw new Error("Failed to fetch dashboard");
      }

      const result = await res.json();
      const apiData = result?.data || {};
      const cd = apiData?.companyDetails || {};

      setDashboardData((prev) => ({
        ...prev,
        ...local,
        company_name: cd.company_name ?? local.company_name ?? "",
        licensedFor: cd.licensedFor ?? local.licensedFor ?? "",
        admin_active: Number(cd.admin_active ?? local.admin_active ?? 0),
        company_address: cd.company_address ?? local.company_address ?? "",
        company_phone: cd.company_phone ?? local.company_phone ?? "",
        admin_email: cd.admin_email ?? local.admin_email ?? "",
        company_logo: cd.company_logo ?? local.company_logo ?? "",
        user_map: cd.user_map ?? local.user_map ?? "",
        totalGuards: Number(apiData.totalGuards ?? 0),
        activeRoutes: Number(apiData.totalRoutes ?? 0),
        hasIsActive: false,
      }));

      setSentinelData({
        totalGuards: Number(apiData.sentinelGuards ?? 0),
        totalRoutes: Number(apiData.sentinelRoutes ?? 0),
        loading: false,
        error: false,
      });
    } catch (error) {
      console.error("[AdminDashboard] fetch error:", error);

      setDashboardData((prev) => ({
        ...prev,
        totalGuards: 0,
        activeRoutes: 0,
        hasIsActive: false,
      }));

      setSentinelData({
        totalGuards: 0,
        totalRoutes: 0,
        loading: false,
        error: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const routePage = useMemo(
    () =>
      dashboardData.user_map === "google"
        ? "/route-master"
        : "/route-master1",
    [dashboardData.user_map]
  );

  const isActive = Number(dashboardData.admin_active) === 1;

  if (loading) {
    return (
      <div className="min-h-screen bg-[var(--page-bg)] flex flex-col items-center justify-center gap-3">
        <div className="w-9 h-9 border-3 border-[var(--accent-faint)] border-t-[var(--accent)] rounded-full animate-spin" />
        <p className="text-sm text-[var(--text-muted)] font-['Inter',system-ui,sans-serif]">
          Loading dashboard...
        </p>
      </div>
    );
  }

  return (
    <Layout
      dashboardData={dashboardData}
      routePage={routePage}
      activePage="dashboard"
      activeMenu="dashboard"
    >
      <div className="font-['Inter',system-ui,sans-serif] text-[var(--text-primary)]">
        <h1 className="text-[22px] font-extrabold text-[var(--text-primary)] tracking-tight m-0">
          {isGuardDashboard ? "Guard Dashboard" : "Company License Management"}
        </h1>

        <p className="text-[13px] text-[var(--text-muted)] m-0 mb-[22px]">
          {isGuardDashboard
            ? "Guard access dashboard & operational details"
            : "Licensed company information & operational details"}
        </p>

        <div className="relative overflow-hidden bg-[var(--card-bg)] border border-[var(--card-border)] rounded-2xl p-4 sm:p-6 shadow-[0_8px_32px_rgba(0,0,0,0.35)] mb-[18px]">
          <div className="absolute top-0 left-0 right-0 h-[3px] bg-[var(--accent)]" />

          <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
            <div className="w-20 h-20 rounded-xl bg-[var(--page-bg)] border-2 border-[var(--accent)] shadow-[0_0_0_3px_var(--accent-glow)] flex items-center justify-center overflow-hidden flex-shrink-0">
              <img
                src={logo}
                alt="Company Logo"
                className="w-full h-full object-contain"
              />
            </div>

            <div className="flex-1 text-center sm:text-left min-w-[200px]">
              <p className="text-[22px] font-extrabold text-[var(--text-primary)] tracking-tight m-0">
                {dashboardData.company_name || "Company Name"}
              </p>

              <p className="text-[12.5px] text-[var(--text-muted)] m-0 mb-2.5">
                {dashboardData.licensedFor || "Licensed Service"}
              </p>

              <span
                className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[11.5px] font-bold ${
                  isActive
                    ? "bg-[var(--accent-faint)] border border-[var(--accent-border)] text-[var(--accent)]"
                    : "bg-[var(--red-faint)] border border-[var(--red-border)] text-[var(--red)]"
                }`}
              >
                <span
                  className={`w-1.5 h-1.5 rounded-full ${
                    isActive ? "bg-[var(--accent)]" : "bg-[var(--red)]"
                  }`}
                />
                {isActive ? "Active" : "Inactive"}
              </span>
            </div>

            <div className="hidden sm:flex items-center gap-1.5 bg-[var(--accent-faint)] border border-[var(--accent-border)] px-3 py-1 rounded-full flex-shrink-0">
              <IcoPaw />
              <span className="text-[10.5px] font-bold tracking-wide uppercase text-[var(--accent)]">
                eBLACKDOG System
              </span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-[18px]">
          <div className="bg-[var(--card-bg)] border border-[var(--card-border)] rounded-2xl p-4 sm:p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)]">
            <div className="flex items-center gap-2 mb-4">
              <IcoBuilding />
              <p className="text-[12px] font-bold tracking-wide uppercase text-[var(--text-sub)] m-0">
                Contact Information
              </p>
              <div className="flex-1 h-px bg-[var(--divider)]" />
            </div>

            {[
              {
                label: "Address",
                icon: <IcoPin />,
                value: dashboardData.company_address,
              },
              {
                label: "Phone",
                icon: <IcoPhone />,
                value: dashboardData.company_phone,
              },
              {
                label: "Email",
                icon: <IcoMail />,
                value: dashboardData.admin_email,
              },
            ].map(({ label, icon, value }) => (
              <div
                key={label}
                className="flex items-start gap-3 py-3 border-b border-[var(--divider)] last:border-b-0 last:pb-0"
              >
                <div className="w-[34px] h-[34px] rounded-xl bg-[var(--accent-faint)] border border-[var(--accent-border)] flex items-center justify-center text-[var(--accent)] flex-shrink-0">
                  {icon}
                </div>

                <div className="flex-1 min-w-0">
                  <p className="text-[10px] font-bold tracking-wide uppercase text-[var(--text-faint)] m-0 mb-0.5">
                    {label}
                  </p>
                  <p className="text-[13.5px] font-medium text-[var(--text-primary)] m-0 break-words">
                    {value || "—"}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-[var(--card-bg)] border border-[var(--card-border)] rounded-2xl p-4 sm:p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)]">
            <div className="flex items-center gap-2 mb-4">
              <IcoShield size={13} color="var(--accent)" />
              <p className="text-[12px] font-bold tracking-wide uppercase text-[var(--text-sub)] m-0">
                Operational Statistics
              </p>
              <div className="flex-1 h-px bg-[var(--divider)]" />
            </div>

            {!isGuardDashboard && (
              <>
                <p className="text-[10px] font-bold tracking-wide uppercase text-[var(--text-faint)] m-0 mb-2.5">
                  Main Flow
                </p>

                <div className="grid grid-cols-2 gap-3">
                  <div className="relative overflow-hidden rounded-xl p-4 bg-[var(--btn-bg)] shadow-[0_4px_18px_var(--accent-glow)]">
                    <div className="absolute right-[-10px] top-[-10px] w-14 h-14 rounded-full bg-white/10" />
                    <div className="flex items-center gap-1.5 mb-1.5">
                      <IcoGuard />
                      <p className="text-[10px] font-bold tracking-wide uppercase text-[var(--btn-text)] opacity-75 m-0">
                        Total Guards
                      </p>
                    </div>
                    <p className="text-[34px] font-extrabold leading-none m-0 text-[var(--btn-text)]">
                      {dashboardData.totalGuards}
                    </p>
                  </div>

                  <div className="relative overflow-hidden rounded-xl p-4 bg-[var(--surface)] border border-[var(--surface-border)]">
                    <div className="absolute right-[-10px] top-[-10px] w-14 h-14 rounded-full bg-[var(--accent-faint)]" />
                    <div className="flex items-center gap-1.5 mb-1.5">
                      <IcoRoute />
                      <p className="text-[10px] font-bold tracking-wide uppercase text-[var(--text-faint)] m-0">
                        Total Routes
                      </p>
                    </div>
                    <p className="text-[34px] font-extrabold leading-none m-0 text-[var(--accent)]">
                      {dashboardData.activeRoutes}
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-2.5 my-4">
                  <div className="flex-1 h-px bg-[var(--divider)]" />
                  <div className="flex items-center gap-1.5 px-3 py-1 rounded-full bg-[var(--accent-faint)] border border-[var(--accent-border)]">
                    <IcoShield size={11} color="var(--accent)" />
                    <span className="text-[10px] font-bold tracking-wide uppercase text-[var(--accent)]">
                      Sentinel Flow
                    </span>
                  </div>
                  <div className="flex-1 h-px bg-[var(--divider)]" />
                </div>

                {sentinelData.loading ? (
                  <div className="flex items-center gap-2.5 py-3.5">
                    <div className="w-[18px] h-[18px] border-2.5 border-[var(--accent-faint)] border-t-[var(--accent)] rounded-full animate-spin" />
                    <span className="text-[13px] text-[var(--text-muted)]">
                      Loading sentinel data...
                    </span>
                  </div>
                ) : sentinelData.error ? (
                  <div className="flex items-center gap-2.5 px-4 py-3 rounded-xl bg-[var(--red-faint)] border border-[var(--red-border)] text-[13px] text-[var(--red)]">
                    <IcoAlert />
                    <span>Unable to load sentinel data</span>
                  </div>
                ) : (
                  <div className="grid grid-cols-2 gap-3">
                    <div className="relative overflow-hidden rounded-xl p-4 bg-[var(--accent-faint)] border border-[var(--accent-border)]">
                      <div className="absolute right-[-10px] top-[-10px] w-14 h-14 rounded-full bg-[var(--accent-glow)]" />
                      <div className="flex items-center gap-1.5 mb-1.5">
                        <IcoShield size={13} color="var(--accent)" />
                        <p className="text-[10px] font-bold tracking-wide uppercase text-[var(--accent)] m-0">
                          Sentinel Guards
                        </p>
                      </div>
                      <p className="text-[34px] font-extrabold leading-none m-0 text-[var(--text-primary)]">
                        {sentinelData.totalGuards}
                      </p>
                    </div>

                    <div className="relative overflow-hidden rounded-xl p-4 bg-[var(--accent-faint)] border border-[var(--accent-border)]">
                      <div className="absolute right-[-10px] top-[-10px] w-14 h-14 rounded-full bg-[var(--accent-glow)]" />
                      <div className="flex items-center gap-1.5 mb-1.5">
                        <IcoShield size={13} color="var(--accent)" />
                        <p className="text-[10px] font-bold tracking-wide uppercase text-[var(--accent)] m-0">
                          Sentinel Routes
                        </p>
                      </div>
                      <p className="text-[34px] font-extrabold leading-none m-0 text-[var(--text-primary)]">
                        {sentinelData.totalRoutes}
                      </p>
                    </div>
                  </div>
                )}
              </>
            )}

            {isGuardDashboard && (
              <div className="rounded-xl p-4 bg-[var(--accent-faint)] border border-[var(--accent-border)]">
                <div className="flex items-center gap-2 mb-2">
                  <IcoShield size={15} color="var(--accent)" />
                  <p className="text-[13px] font-bold text-[var(--accent)] m-0">
                    Guard Login Active
                  </p>
                </div>
                <p className="text-[13px] text-[var(--text-muted)] m-0">
                  You are logged in as a guard. Admin-only dashboard API calls
                  are skipped for this session.
                </p>
              </div>
            )}

            <div className="flex flex-wrap gap-2.5 mt-4 pt-4 border-t border-[var(--divider)]">
              {isGuardDashboard
                ? [
                   
                  ].map(({ label, to }) => (
                    <Link
                      key={label}
                      to={to}
                      className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-xl bg-[var(--accent-faint)] border border-[var(--accent-border)] text-[var(--accent)] text-[12.5px] font-semibold no-underline transition-all hover:bg-[var(--btn-bg)] hover:text-[var(--btn-text)] hover:shadow-[0_4px_14px_var(--accent-glow)]"
                    >
                      {label}
                      <IcoArrow />
                    </Link>
                  ))
                : [
                    { label: "View Users", to: "/user_list" },
                    { label: "Route List", to: "/route_list" },
                    { label: "Analytics", to: "/analytics" },
                  ].map(({ label, to }) => (
                    <Link
                      key={label}
                      to={to}
                      className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-xl bg-[var(--accent-faint)] border border-[var(--accent-border)] text-[var(--accent)] text-[12.5px] font-semibold no-underline transition-all hover:bg-[var(--btn-bg)] hover:text-[var(--btn-text)] hover:shadow-[0_4px_14px_var(--accent-glow)]"
                    >
                      {label}
                      <IcoArrow />
                    </Link>
                  ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}